const characters = [
    {
        id: 'marc',
        asset: { kind: 'image', src: '/static/assets/marc.png' },
    },
    {
        id: 'sarah',
        asset: { kind: 'image', src: '/static/assets/sarah.png' },
    },
    {
        id: 'mirko',
        asset: { kind: 'image', src: '/static/assets/mirko.png' },
    },
    {
        id: 'jon',
        asset: { kind: 'image', src: '/static/assets/jon.png' },
    },
    {
        id: 'Redcap',
        asset: { kind: 'image', src: '/static/assets/Redcap.png' },
    },
    {
        id: 'Wolf',
        asset: { kind: 'image', src: '/static/assets/Wolf.png' },
    },
];

export { characters };
